<template>
<router-view></router-view>
</template>

<script>
export default {
  name: "resourceIndex"
}
</script>

<style scoped>

</style>